import React, { ReactNode, useState } from 'react'
import BaseChart from '../baseChart/BaseChart'
import { ResponsiveScatterPlot } from '@nivo/scatterplot'
import { Container } from './Styled'

type ScatterPlotProps = {
    data: any;
    title: string;
    colors?: any;
    legends: string[];
    tooltip?: (node: ReactNode) => any;
    showDrawer?: (event: any) => void;
}

const ScatterPlot: React.FunctionComponent<ScatterPlotProps> = ({
    data,
    title,
    colors,
    legends,
    tooltip,
    showDrawer
}) => {

    return (
        <Container>
            <BaseChart title={title}>
                <ResponsiveScatterPlot
                    data={data}
                    margin={{ top: 60, right: 140, bottom: 90, left: 90 }}
                    xFormat={function (e) { return e + " kg" }}
                    yFormat={function (e) { return e + " cm" }}
                    blendMode="multiply"
                    colors={colors}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        orient: 'bottom',
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: legends[1],
                        legendPosition: 'middle',
                        legendOffset: 50
                    }}
                    tooltip={tooltip}

                    axisLeft={{
                        orient: 'left',
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: legends[0],
                        legendPosition: 'middle',
                        legendOffset: -60
                    }}
                    onClick={(event) => { if (showDrawer) showDrawer(event) }}
                />
            </BaseChart>
        </Container>
    )
}

export default ScatterPlot